import { render } from "./perda.vue?vue&type=template&id=b941e21a&scoped=true"
import script from "./perda.vue?vue&type=script&lang=js"
export * from "./perda.vue?vue&type=script&lang=js"

import "./perda.vue?vue&type=style&index=0&id=b941e21a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b941e21a"]])

export default __exports__